import cx from 'classnames';
import type { FunctionComponent, PropsWithChildren } from 'react';

import { useBoardSwitcherLayout } from '@trello/board-switcher';

import * as styles from './BoardSwitcherTiles.module.less';

interface BoardSwitcherTilesProps {
  testId?: string;
  className?: string;
}

export const BoardSwitcherTiles: FunctionComponent<
  PropsWithChildren<BoardSwitcherTilesProps>
> = ({ children, testId, className }) => {
  const layout = useBoardSwitcherLayout();

  return (
    <div
      className={cx({
        [styles.boardList]: layout === 'list',
        [styles.boardTiles]: layout === 'grid',
        [className as string]: !!className,
      })}
      data-testid={testId}
      role={layout}
    >
      {children}
    </div>
  );
};
